$bog_GPTHub_logo $mol_icon_molecule
